import React, { useState } from "react";
import "./Footer.scss";
import PrivacyPolicy from "../PrivacyPolicy/PrivacyPolicy";

const Footer = () => {
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);

  const togglePrivacyModal = () => {
    setIsPrivacyModalOpen((prev) => !prev);
  };

  return (
    <>
      {/* Render Privacy Policy Modal */}
      {isPrivacyModalOpen && (
        <PrivacyPolicy
          isOpen={isPrivacyModalOpen}
          onClose={togglePrivacyModal}
        />
      )}
      <footer className="footer">
        <div className="footer-content">
          <p>&copy; {new Date().getFullYear()} tldr works. All Rights Reserved.</p>
          <ul className="footer-links">
            <li>
              <a onClick={togglePrivacyModal}>
                Privacy Policy
              </a>
            </li>
          </ul>
        </div>
      </footer>
    </>
  );
};

export default Footer;
